<script setup lang="ts">
  import { computed } from 'vue'
  import { fmt } from '@/functions'

  const props = defineProps<{
    item: {
      price: number,
      charge_type: 'Biaya' | 'Diskon',
      charge_percentage: number,
      charge_rupiah: number,
    },
  }>()

  const discountPercentage = computed(() => {
    return fmt.roundedPercentage(
      props.item.charge_percentage,
      props.item.charge_rupiah,
      props.item.price,
    )
  })
</script>

<template>
  <div
    v-show="item.charge_rupiah"
    class="inline-flex items-center space-x-2">
    <div
      class="whitespace-nowrap py-0.5 text-xs font-semibold"
      :class="{
        'text-danger-500': item.charge_type === 'Diskon',
        'text-success-500': item.charge_type === 'Biaya'
      }">
      <fa-icon :icon="item.charge_type === 'Biaya' ? 'i-fas-caret-up' : 'i-fas-caret-down'" />
      {{ discountPercentage }}%
    </div>
    <span class="text-strike text-sm text-gray">
      {{ fmt.number(item.price) }}
    </span>
  </div>
</template>

<style lang="postcss" scoped>
  .text-strike {
    text-decoration: underline 1px;
    text-underline-offset: -0.25rem;
    text-decoration-skip-ink: none;
  }
</style>
